module.exports = __webpack_public_path__ + "img/task.88c98472.svg";